import React from "react";

interface Props {
  travellers: server.dto.ContactSmallV2[]
}

const Travellers = ({ travellers }: Props) => {
  const isLastTraveller = (index) => travellers.length === (index + 1);
  return <>
    {travellers.map((traveller, index) => (
      <span key={traveller.contactId} style={{ whiteSpace: "nowrap" }}>
        {traveller.name.fullName}{!isLastTraveller(index) && ", "}
      </span>
    ))}
  </>;
};

export default Travellers;
